import React from "react";
import Huawei from "../../assets/icons/Huawei.svg";
import Button from "../Button";
/**
 *
 * @param {string} theme Choose a theme between dark and light
 * @param {number} height Controls the height of the button
 * @param {number} width Controls the width of the button
 * @param {string} title Set custom title for the button
 * @param {string} className Add className to the button in order to customize the button appearance
 * @param {string} url Add your store url to the button
 * @example <AppGalleryButton theme="light" height={70} width={130} className="button-container" url="https://appgallery.huawei.com/" />
 * @returns
 */
var AppGalleryButton = function AppGalleryButton(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? "light" : _ref$theme,
    height = _ref.height,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "EXPLORE IT ON" : _ref$title,
    width = _ref.width,
    className = _ref.className,
    url = _ref.url;
  return /*#__PURE__*/React.createElement(Button, {
    theme: theme,
    height: height,
    width: width,
    url: url,
    storeName: "AppGallery",
    logo: Huawei,
    className: className,
    title: title
  });
};
export default AppGalleryButton;